import { RESET_DEEP_MODAL_TRANSFER_PAYLOAD, SET_DEEP_MODAL_TRANSFER_PAYLOAD } from "../actions/global-actions-types";


const INITIAL_STATE_DEEP_MODAL_TRANSFER_PAYLOAD = { results: "" }

export function setDeepModalTransferPayloadReducer(state = INITIAL_STATE_DEEP_MODAL_TRANSFER_PAYLOAD, action) {
    switch (action.type) {
        case SET_DEEP_MODAL_TRANSFER_PAYLOAD:
            return { results: action.payload };
        case RESET_DEEP_MODAL_TRANSFER_PAYLOAD:
            return INITIAL_STATE_DEEP_MODAL_TRANSFER_PAYLOAD
        default:
            return state;
    }
}